import React, {useState} from "react";
import useGoToNavigation from "../../../../util/useGotoNavigation";
import {ExchangeCreateType} from "./interface";
import {exchangeCreateInit} from "./state";
import {SubmitHandler, useForm, useWatch} from "react-hook-form";
import {useCreateExchangeRate} from "./hooks/useCreateExchangeRate";
import {useModal} from "../../../../hooks";

export default function ExchangeCreate() {
    const {handleModal} = useModal();
    const {goToNavigation} = useGoToNavigation();

    const {mutate: mutateCreateExchangeRate} = useCreateExchangeRate()

    const [createData, setCreateData] = useState<ExchangeCreateType>(exchangeCreateInit)

    const {register, handleSubmit, getValues, setValue, watch, control} = useForm({
        defaultValues: createData,
    });

    const watchCreateData = {
        ...createData,
        ...useWatch<ExchangeCreateType>({control}),
    };

    const btnCancel = () => {
        goToNavigation("main/exchange", {}, false)
    }

    const onSubmit: SubmitHandler<ExchangeCreateType> = (submitData) => {
        if (getValues("noticeBaseDate") === "") {
            handleModal({
                isOpen: true,
                contents: "고시 기준일을 입력해주세요.",
                type: "alert",
            });
        } else if (getValues("noticeRound") === "") {
            handleModal({
                isOpen: true,
                contents: "고시 회차를 입력해주세요.",
                type: "alert",
            });
        } else {
            mutateCreateExchangeRate(submitData)
        }
    };

    return <div className="content_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">환율 직접 등록</h3>
            <div className="filter_toolbar">
                <button className="btn btn-info w-100px h-38px" onClick={handleSubmit(onSubmit)}>저장
                </button>
                <button className="btn btn-outline-secondary w-100px h-38px" onClick={btnCancel}>취소
                </button>
            </div>
        </div>

        <h5 className="subheading">환율 정보</h5>
        <table className="table table-bordered my_table">
            <tbody>
            <tr>
                <th style={{width: "16.66%"}}>고시 기준일</th>
                <td className="p-4px"
                    style={{width: "33.3%"}}>
                    <input type="date"
                           className="form-control"
                           max="9999-12-31"
                           value={watchCreateData.noticeBaseDate} {...register("noticeBaseDate")}
                    />
                </td>
                <th style={{width: "16.66%"}}>고시 회차</th>
                <td className="p-4px"
                    style={{width: "33.3%"}}>
                    <input type="text" className="form-control"
                           value={watchCreateData.noticeRound} {...register("noticeRound")}
                    />
                </td>
            </tr>
            </tbody>
        </table>

        <div className="table_top mb-10px align-items-end">
            <h6 className="table_stats">환율정보 상세</h6>
            <div className="table_toolbar"></div>
        </div>

        <table className="table table-bordered my_table mb-0">
            <thead>
            <tr>
                <th rowSpan={2} style={{width: "16.66%"}}>통화</th>
                <th colSpan={2} style={{width: "33.33%"}}>현찰</th>
                <th colSpan={2} style={{width: "33.33%"}}>송금</th>
                <th rowSpan={2}>매매기준율</th>
                {/*<th rowSpan={2}>미화환산율</th>*/}
            </tr>
            <tr>
                <th style={{width: "16.66%"}}>보낼 때</th>
                <th style={{width: "16.66%"}}>받을 때</th>
                <th style={{width: "16.66%"}}>보낼 때</th>
                <th>받을 때</th>
            </tr>
            </thead>
            <tbody>
            {watchCreateData.exchangeRateDetailReqList.map((el, idx) =>
                <tr>
                    <td className="text-center p-4px">
                        {el.currencyTypeName}
                    </td>
                    <td className="text-end p-4px">
                        <input type="text"
                               className="form-control"
                               {...register(`exchangeRateDetailReqList.${idx}.cashBuyRate`)}
                        />
                    </td>
                    <td className="text-end p-4px">
                        <input type="text"
                               className="form-control"
                               {...register(`exchangeRateDetailReqList.${idx}.cashSellRate`)}
                        />
                    </td>
                    <td className="text-end p-4px">
                        <input type="text"
                               className="form-control"
                               {...register(`exchangeRateDetailReqList.${idx}.remittanceSendRate`)}
                        />
                    </td>
                    <td className="text-end p-4px">
                        <input type="text"
                               className="form-control"
                               {...register(`exchangeRateDetailReqList.${idx}.remittanceReceiveRate`)}
                        />
                    </td>
                    <td className="text-end p-4px">
                        <input type="text"
                               className="form-control"
                               {...register(`exchangeRateDetailReqList.${idx}.baseExchangeRate`)}
                        />
                    </td>
                    {/*<td className="text-end p-4px">*/}
                    {/*    <input type="text"*/}
                    {/*           className="form-control"*/}
                    {/*           {...register(`exchangeRateDetailReqList.${idx}.usdConversionRate`)}*/}
                    {/*    />*/}
                    {/*</td>*/}
                </tr>
            )}
            </tbody>
        </table>
    </div>
}